export default __webpack_public_path__ + "static/media/OOHProposalChitraB.79a2037f.xlsx";